<div class="galleries">
  <a
    *ngFor="let gallery of galleries; trackBy: galleryTrackFn"
    [routerLink]="links[gallery.id]"
    [target]="embedMode ? '_blank' : '_self'"
  >
    <app-gallery-item [gallery]="gallery" [publicMode]="true"> </app-gallery-item>
  </a>
</div>
